module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/taneyah-morris-hill-5c34d9fc901dcd60b409deddd7d6aa52.jpg";